/**
 * Contains translations for different languages used in the application.
 *
 * @constant
 * @type {Object.<string, Object.<string, string>>}
 */
export const translations = {
  en: {
    profile: "Profile",
    settings: "Settings",
    login: "Login",
    logout: "Logout",
    noCards: "No cards available",
    vouchers: "Memeber benefits",
    tickets: "Tickets",
    noVouchers: "No vouchers available",
    redeem: "Redeem",
    adminDashboard: "Admin Dashboard",
    mobile: "Mobile",
    save: "Save",
    saveChanges: "Save changes",
    yourCards: "Member benefits",
    moreVouchersComingSoon: "More vouchers coming soon",
    moreEventsComingSoon: "More events coming soon!",
    noTickets: "No past order found",
    currencyConversions: "Currency conversions will be applied at checkout",
    nonRefundable: "Tickets are non-refundable",
    vouchersDescription:
      "We provide local vouchers exclusively to our members. Click on them to show at checkout and enjoy!",
    trialPopupTitle: "Welcome to our Voucher Trial!",
    trialPopupDescription:
      "You've been granted access to our brand new Voucher system for a limited time. Explore and enjoy the benefits!",
    dismissButton: "Dismiss",
    cityfilter: "Filter upcoming events by city",

    cookieConsentMessage:
      "We use cookies to run this site and, with your permission, to understand how it's used so we can improve it.",
    cookieConsentLearnMore: "Learn more",
    cookieConsentAcceptAll: "Accept all",
    cookieConsentRejectAll: "Reject non-essential",
    cookieConsentCustomize: "Customize",
    cookieConsentBack: "Back",
    cookieConsentSavePreferences: "Save preferences",
    cookieConsentNecessaryTitle: "Necessary cookies",
    cookieConsentNecessaryBody:
      "Required for the site to work — can't be turned off.",
    cookieConsentAnalyticsTitle: "Analytics cookies",
    cookieConsentAnalyticsBody:
      "Helps us understand how the site is used so we can improve it.",
    cookieConsentAlwaysOn: "Always on",

    // Landing page
    landingNavTatoClub: "Tato Club",
    landingNavOffers: "Member offers",
    landingNavListEvent: "List an event",
    landingNavPartner: "Become a partner",
    landingNavAbout: "About",
    landingNavBusiness: "For Business",
    landingNavDownload: "Get the App",
    landingNavSignin: "Sign in",
    landingNavJoin: "Join",
    landingNavBack: "← Back to site",

    landingHeroKicker: "A Small Potatoes city guide",
    landingHeroTitle: "Discover the best food, fun and places in your city.",
    landingHeroSubtitle:
      "Curated events and local favourites, is there anywhere in your city worth going to? We help you find it.",
    landingHeroCtaPrimary: "Explore your city",
    landingHeroCtaSecondary: "Join Tato Club",
    landingHeroCtaSecondaryNote: "The Small Potatoes membership app",
    landingHeroCitiesLabel: "Now in",
    landingHeroFeature1: "Hot events",
    landingHeroFeature2: "Independent venues",
    landingHeroFeature3: "Member perks",

    landingPicksKicker: "Selected Picks",
    landingPicksBadge: "Small Potatoes Pick",
    landingPicksHeading: "Top 10 places in {city}",
    landingPicksSubtitle:
      "Hand-picked local favourites. Every place has a reason to be chosen.",
    landingPicksCtaMore: "View all places",
    landingPicksBackToHome: "← Back to home",
    landingPicksBackToList: "← Back to list",
    landingPicksHighlightsHeading: "Highlights",
    landingPicksDetailsHeading: "Place details",
    landingPicksMorePlacesHeading: "More Local Places",

    // Vibe / "occasion" filter on the places list. {city} and {vibe} are
    // interpolated at render time. Per-vibe SEO copy powers the
    // /places/:city/mood/:vibe landing pages.
    vibeFilterAll: "All",
    vibeFilterEmpty: "No {vibe} places in {city} yet — check back soon.",
    vibeHomeKicker: "Find your spot",
    vibeHomeHeading: "What are you in the mood for?",
    vibeHomeSubtitle: "Pick an occasion and we'll show you the places that fit.",
    vibeDateNightLabel: "Date night",
    vibeWithTheGroupLabel: "With the group",
    vibeSoloLabel: "Solo",
    vibeFamilyLabel: "Family-friendly",
    vibeSpecialOccasionLabel: "Special occasion",
    vibeQuickBiteLabel: "Quick bite",
    vibeRainyDayLabel: "Rainy day",
    vibeWorkFriendlyLabel: "Work-friendly",
    vibeDogFriendlyLabel: "Dog-friendly",
    vibeDateNightSeoTitle: "Date night places in {city} | Small Potatoes",
    vibeDateNightSeoDesc: "Hand-picked independent {city} spots for a date night.",
    vibeWithTheGroupSeoTitle: "Group-friendly places in {city} | Small Potatoes",
    vibeWithTheGroupSeoDesc: "Hand-picked independent {city} spots for going out with the group.",
    vibeSoloSeoTitle: "Places for a solo outing in {city} | Small Potatoes",
    vibeSoloSeoDesc: "Hand-picked independent {city} spots for a solo outing.",
    vibeFamilySeoTitle: "Family-friendly places in {city} | Small Potatoes",
    vibeFamilySeoDesc: "Hand-picked independent {city} spots for a day out with the kids.",
    vibeSpecialOccasionSeoTitle: "Special-occasion places in {city} | Small Potatoes",
    vibeSpecialOccasionSeoDesc: "Hand-picked independent {city} spots for celebrating something.",
    vibeQuickBiteSeoTitle: "Quick bites in {city} | Small Potatoes",
    vibeQuickBiteSeoDesc: "Hand-picked independent {city} spots for a quick bite.",
    vibeRainyDaySeoTitle: "Rainy-day places in {city} | Small Potatoes",
    vibeRainyDaySeoDesc: "Hand-picked independent {city} spots for a rainy afternoon.",
    vibeWorkFriendlySeoTitle: "Work-friendly places in {city} | Small Potatoes",
    vibeWorkFriendlySeoDesc: "Hand-picked independent {city} spots for getting work done.",
    vibeDogFriendlySeoTitle: "Dog-friendly places in {city} | Small Potatoes",
    vibeDogFriendlySeoDesc: "Hand-picked independent {city} spots for a walk with the dog.",

    shareLabel: "Share",
    shareCopied: "Link copied!",

    navGuides: "Things to do",

    guidesKicker: "Things to do",
    guidesHeading: "Ways to experience {city}",
    guidesHeadingAll: "Ways to experience the city",
    guidesSubtitle:
      "Curated routes through the places worth knowing — for a slow afternoon, a rainy day, or somewhere new to explore.",
    guidesBackToHome: "← Back to home",
    guidesBackToGuides: "← Back to guides",
    guidesEmptyTitle: "More guides are on the way.",
    guidesEmptyBody:
      "We're still writing. Check back soon for new ways to explore {city}.",
    guidesEmptyBodyAll:
      "We're still writing. Check back soon for new ways to explore the city.",
    guidesErrorTitle: "Something went wrong.",
    guidesErrorBody:
      "We couldn't load these guides right now. Please try again shortly.",
    guidesNotFoundTitle: "Guide not found",
    guidesNotFoundBody:
      "This guide doesn't exist, or may no longer be available.",
    notFoundTitle: "Page not found",
    notFoundBody:
      "We couldn't find the page you're looking for. It may have moved, or the link might be out of date.",
    notFoundBackHome: "← Back to home",
    guidesCardCta: "Read the guide",
    guideTypeGuide: "Guide",
    guideTypeItinerary: "Itinerary",
    guideTypeRoundup: "Roundup",
    guideTypeStory: "Story",
    guidePlaceCardCta: "View Place",
    guideMetaSeparator: "·",

    landingEventsKicker: "Events",
    landingEventsHeading: "What's on in {city} this month",
    landingEventsSubtitle: "Upcoming shows and events by city",
    landingEventsCtaMore: "See all and book in the app",
    landingEventsEmpty: "No events in this city yet — check back soon.",

    landingOffersHeading: "Member offers",
    landingOffersSubtitle: "Join Tato Club and save a little on every visit.",
    landingOffersBadge: "Member Offer",

    landingGuidesKicker: "Guides",
    landingGuidesHeading: "Latest Guides",
    landingGuidesSubtitle: "Curated ways to eat, wander and discover the city.",
    landingGuidesCtaMore: "Explore all Guides",

    landingTatoClubKicker: "Tato Club",
    landingTatoClubHeading: "Take Small Potatoes with you",
    landingTatoClubBody:
      "Join Tato Club to save your favourite places, access member offers and discover what to do next.",
    landingTatoClubCta: "Download Tato Club",
    landingTatoClubSecondary: "The official Small Potatoes membership app",

    landingAboutKicker: "About",
    landingAboutHeading: "We believe a city's character is in the details",
    landingAboutBody:
      "We started with a group of people living across the UK. We often spent far too long piecing together scattered information just to find a restaurant we'd truly love, or an event worth going to. So we thought it could be helpful to come up with a guide to list out all the local favourites.",
    landingAboutValue1Title: "Recommendations you can trust",
    landingAboutValue1Body:
      "We know there are many existing ways to find great places, but we do feel advertisements can sometimes be overwhelming. Every place listed on Small Potatoes are either hand-picked or personally experienced by our local team. No sponsored content, no paid placements, just honest recommendations.",
    landingAboutValue2Title: "Instant tickets",
    landingAboutValue2Body:
      "Well...not literally instant, we are trying to get more fun experiences listed out here, please stay in tune",
    landingAboutValue3Title: "A guide that keeps growing",
    landingAboutValue3Body:
      "Either a weekend away or a rainy day, we are always looking for new places to explore and share with our members. Don't forget to subscribe to our newsletter to get the latest updates on new places and events in your city.",
    landingAboutStoryKicker: "Our Story",
    landingAboutStoryHeading: "A city is more than its loudest names",
    landingAboutStoryBody:
      "All cities are different from one another, we have been thinking what makes each unique. We think the main thing about a city is the places that hold their own point of view, the ones you want to return to. We bring events, independent venues and local experiences together, so every recommendation helps you know the city a little better.",
    landingAboutBeliefQuote:
      '"Every Small Potatoes Pick is personally experienced and chosen by our local team."',
    landingAboutClosingHeading: "Adding a little more color to everyday life",
    landingAboutClosingBody:
      "That's why we built more into membership, early-bird tickets, business surprises and exclusive deals, so exploring always feels worth it.",
    landingAboutClosingCta: "Become a member",

    landingBizTeaserHeading: "Own a local business?",
    landingBizTeaserBody:
      "List your events or get discovered on Small Potatoes.",
    landingBizTeaserCta: "Partner with us",

    landingBizPortalKicker: "For Business",
    landingBizPortalHeading: "Welcome back",
    landingBizPortalSubtitle: "Log in to manage your events and venue listing",
    landingBizPortalEmailLabel: "Email",
    landingBizPortalPasswordLabel: "Password",
    landingBizPortalForgot: "Forgot password?",
    landingBizPortalLoginBtn: "Log in",
    landingBizPortalNoAccount: "Don't have a business account?",
    landingBizPortalApply: "Apply now",
    landingBizPortalSideKicker: "For Partners",
    landingBizPortalSideHeading: "Why join small potatoes",
    landingBizPortalSide1: "Reach people actively looking nearby",
    landingBizPortalSide1Sub:
      "Connect with local explorers across London, Birmingham and Southampton",
    landingBizPortalSide2: "Simple event publishing and ticket management",
    landingBizPortalSide2Sub: "Publish in minutes, track sales with ease",
    landingBizPortalSide3: "One dashboard for your listing and events",
    landingBizPortalSide3Sub: "Your listing, perks and events all in one place",
    landingBizPortalLoginError: "Incorrect email or password.",

    dashTabEvents: "Events",
    dashTabUsers: "Users",
    dashTabCards: "Cards",
    dashTabStores: "Places",
    dashTabVouchers: "Vouchers",
    dashTabPosts: "Posts",
    dashTabNewsletter: "Newsletter",
    dashAccount: "Small potatoes account",
    dashSwitchToMember: "Switch to Member Page",
    dashUpcoming: "Upcoming",
    dashPast: "Past",
    dashAllCities: "All Cities",
    dashAllStatuses: "All Statuses",
    dashFilterByCity: "Filter events by city",
    dashCreateEvent: "Create Event",
    dashColSales: "Sales",
    dashColRevenue: "Revenue",
    dashTotalUsers: "Total Registered Users",
    dashCopyEmails: "Copy Marketing Emails",
    dashSearchUser: "Search by name or email…",
    dashQuickSearch: "Search events, users or places…",
    dashNoResults: "No matching results",
    dashWorkspace: "Workspace",
    dashEventsSubtitle: "Manage your events and ticket sales",
    dashNewsletterSubtitle: "View who's subscribed to the Small Potatoes List",
    dashNewsletterTotal: "Total",
    dashNewsletterSubscribed: "Subscribed",
    dashNewsletterUnsubscribed: "Unsubscribed",
    dashNewsletterStatusSubscribed: "Subscribed",
    dashNewsletterStatusUnsubscribed: "Unsubscribed",
    dashNewsletterAllCities: "All cities",
    dashNewsletterConsented: "Consented",
    dashNewsletterUnsubscribedOn: "Unsubscribed",
    dashNewsletterEmpty: "No newsletter subscribers yet.",
    dashNewsletterError: "Couldn't load subscribers. Please try again.",
    addMember: "Add Member",
    addMemberTitle: "Add New Member",
    addMemberSubtitle: "Invite a teammate and set their access",
    editMemberTitle: "Edit Member",
    editMemberSubtitle: "Update this member's role and access",
    memberEmailLabel: "Email Address",
    memberEmailPh: "Enter the member's email address",
    memberRoleLabel: "Role",
    roleUser: "User",
    roleCreator: "Creator",
    roleObserver: "Observer",
    roleStaff: "Staff",
    roleCreatorHint: "Can manage the events assigned to them",
    roleObserverHint: "Can view data for the events assigned to them",
    roleStaffHint: "Can check in tickets at assigned events",
    memberEventsLabel: "Assign events",
    memberEventsEmpty: "No events yet.",
    sendInvite: "Send Invite",
    saveMemberChanges: "Save Changes",
    memberEmailExists:
      "A user with this email already exists. Use Edit from the list instead.",
    memberEmailRequired: "Please enter an email address.",
    memberInviteSent: "Invite sent!",
    memberSaved: "Member updated.",
    edit: "Edit",
    delete: "Delete",
    backToEventsList: "← Back to Events",
    detailVendor: "Vendor",
    detailPriceRange: "Price Range",
    detailSalesEnd: "Sales End",
    detailLastEntry: "Last Entry",
    detailAge: "Age Restriction",
    detailFeatured: "Featured",
    ticketTypesLabel: "Ticket Types",
    qtyLabel: "Qty",
    soldLabel: "Sold",
    availableLabel: "Available",
    totalCreatedLabel: "Total Created",
    totalScannedLabel: "Total Scanned",
    panelFinancials: "Financials",
    panelReferrals: "Referrals",
    panelFreeTickets: "Free Tickets",
    panelPermissions: "Permissions",
    finTotalRevenue: "Total Revenue",
    finOwedOrganizer: "Owed to Organizer",
    finOwedUs: "Owed to Us",
    finStripeFee: "Estimated Stripe Fee",
    finTotalOrders: "Total Orders",
    generateReferral: "Generate Referral Code",
    noReferrals: "No referral codes yet",
    issueFreeTicket: "Issue Free Ticket",
    guestEmail: "Guest Email",
    guestName: "Guest Name",
    selectTicketType: "Select Ticket Type",
    freeReason: "Reason for free ticket",
    maxEntry: "Maximum Entry Count",
    maxEntryHint: "How many times can this ticket be scanned?",
    issuedTickets: "Issued Free Tickets",
    permissionsHint: "Manage your team's access to this event.",
    noMembers: "You haven't added any members yet",
    addNow: "Add Now",
    dashCreateCard: "Create New Card",
    dashCardName: "Card Name",
    dashIdNumber: "Identification Number",
    dashPaid: "Paid",
    dashAutoAssign: "Auto-assign to new users",
    dashColExpiry: "Expiry",
    dashEnterEmail: "Enter user email",
    dashAssignUser: "Assign User",
    dashAssignAll: "Assign All",
    dashNewCompany: "New Place",
    dashAllCards: "All Cards",
    dashNewVoucher: "New Voucher",
    dashCancel: "Cancel",
    statTotalEvents: "Total Events",
    statTotalSales: "Total Sales",
    statTotalRevenue: "Total Revenue",

    dashCreateCompanyTitle: "Create New Place",
    dashEditCompanyTitle: "Edit Place",
    dashUpdateCompanyBtn: "Update Place",
    dashCompanyPhoto: "Place Photo",
    dashDropPhoto: "Drop a place photo here",
    dashBrowseFiles: "browse files",
    dashCompanyNameLabel: "Place Name",
    dashCompanyNamePh: "Enter the place name",
    dashShortDescLabel: "Short Description",
    dashShortDescPh: "A one-line summary of the place",
    dashMaxChars: "Max 100 characters",
    dashCompanyDescLabel: "Place Description",
    dashCompanyDescPh: "Describe what makes this place worth visiting",
    dashCompanyLocationLabel: "Address",
    dashCompanyLocationPh: "Enter the address",
    dashCompanyWebsiteLabel: "Website Link",
    dashCompanyWebsitePh: "https://example.com",
    dashCompanyContactLabel: "Contact Number",
    dashCompanyContactPh: "Enter a phone number",
    dashCategoryLabel: "Category",
    dashCategoryPh: "e.g. Bar, Café, Live Music",
    dashTagsLabel: "Tags",
    dashTagsPh: "Comma-separated free-text, e.g. cocktails, natural wine, terrace",
    dashVibesLabel: "Vibes",
    dashVibesHint: "What's this place good for? Pick the occasions it fits — this powers the mood filter on the places list. Up to 3.",
    dashHighlightsLabel: "Highlights",
    dashHighlightsPh: "One highlight per line",
    dashHighlightsHint: "Shown as a bullet list on the pick detail page",
    dashFeaturedCompany: "Featured Place",
    dashVoucherPlaceLabel: "Place",
    dashSelectPlace: "Select a place",

    dashNewPost: "New Post",
    dashCreatePostTitle: "Create New Post",
    dashEditPostTitle: "Edit Post",
    dashUpdatePostBtn: "Update Post",
    dashPostTitleLabel: "Title",
    dashPostTitlePh: "e.g. A Slow Sunday in Southampton",
    dashPostTypeLabel: "Post Type",
    dashPostTypeGuide: "Guide",
    dashPostTypeItinerary: "Itinerary",
    dashPostTypeRoundup: "Roundup",
    dashPostTypeStory: "Story",
    dashPostExcerptLabel: "Excerpt",
    dashPostExcerptPh: "A short summary shown in listings",
    dashPostHeroImageLabel: "Hero Image",
    dashDropHeroImage: "Drop a hero image here",
    dashPostIntroductionLabel: "Introduction",
    dashPostIntroductionPh: "Set the scene before your first section…",
    dashPostTagsPh: "Comma-separated, e.g. coffee, rainy day, family",
    dashPostStatusLabel: "Status",
    dashPostStatusDraft: "Draft",
    dashPostStatusPublished: "Published",
    dashPostSectionsLabel: "Sections",
    dashPostSection: "Section",
    dashPostSectionHeadingLabel: "Heading",
    dashPostSectionHeadingPh: "e.g. Start with coffee",
    dashPostSectionBodyLabel: "Body",
    dashPostSectionBodyPh: "Write this section…",
    dashPostSectionPlaceNone: "No place",
    dashAddSection: "+ Add Section",
    dashRemoveSection: "Remove",
    dashMoveSectionUp: "Move up",
    dashMoveSectionDown: "Move down",
    dashNoPosts: "No posts available. Create a new post to get started.",

    dashPostStepCover: "Cover",
    dashPostStepContent: "Content",
    dashPostStepPublish: "Publish",
    dashPostStepRequiredError:
      "Please fill in the required fields before continuing.",
    dashPostStepBack: "Back",
    dashPostStepContinue: "Continue",
    dashPostSaveDraft: "Save as draft",
    dashPostPublish: "Publish",
    dashPostPublishUpdate: "Save changes",

    dashPlaceStepCover: "Cover",
    dashPlaceStepContent: "Content",
    dashPlaceStepDetails: "Details",

    dashEditorBold: "Bold",
    dashEditorItalic: "Italic",
    dashEditorUnderline: "Underline",
    dashEditorBulletList: "Bullet list",
    dashEditorOrderedList: "Numbered list",
    dashEditorQuote: "Quote",
    dashEditorLink: "Link",
    dashEditorImage: "Image",
    dashEditorAlignLeft: "Align left",
    dashEditorAlignCenter: "Align center",
    dashEditorAlignRight: "Align right",
    dashEditorHeading2: "Heading",
    dashEditorHeading3: "Subheading",
    dashEditorLinkPrompt: "Enter a URL",
    dashEditorLinkConfirm: "Add",
    dashEditorLinkRemove: "Remove",
    dashEditorImageUploadError: "Couldn't upload that image. Please try again.",
    dashEditorFontLabel: "Font",
    dashEditorFontDefault: "Default font",
    dashEditorFontBody: "Body (Figtree)",
    dashEditorFontHeading: "Display (Caprasimo)",
    dashEditorFontPoppins: "Poppins",

    createEventTitle: "Create New Event",
    editEventTitle: "Edit Event",
    updateEventBtn: "Update Event",
    stepBasics: "Basics",
    stepDetails: "Details",
    stepTickets: "Tickets",
    stepPublish: "Publish",
    sectionImages: "Event Images",
    sectionCity: "City",
    fieldTitle: "Event Title",
    fieldTitlePh: "Enter a catchy title for your event",
    fieldShortDesc: "Short Description",
    fieldShortDescPh: "Brief summary of your event (max 120 characters)",
    fieldFullDesc: "Full Description",
    fieldFullDescPh: "Detailed description of your event",
    fieldStart: "Start Date & Time",
    fieldEnd: "End Date & Time (optional)",
    fieldLocation: "Event Location",
    fieldLocationPh: "Enter the venue or address of the event",
    fieldVendor: "Event Vendor",
    fieldVendorPh: "Name of the event organizer or vendor",
    fieldPriceRange: "Price Range",
    fieldPriceRangePh: "e.g., £20 - £50",
    fieldLastEntry: "Last Entry Time",
    fieldLastEntryPh: "e.g., 11:00 PM",
    fieldAge: "Age Restriction",
    fieldAgePh: "e.g., 18+, All Ages",
    fieldCutoff: "Ticket Sales Cutoff",
    fieldCutoffHint:
      "Leave blank if tickets can be sold until the event starts",
    selectCity: "Select a city",
    citySearchPlaceholder: "Search or enter new city name",
    addCityLabel: "Add city",
    cityRequiredError: "Please select or add a city.",
    ticketsStepHint: "Add at least one ticket type",
    addTicketType: "Add Ticket Type",
    ticketNamePh: "e.g., Early Bird, VIP",
    ticketBadgePh: "e.g., EARLY, VIP",
    ticketDescPh: "Brief description of ticket benefits",
    ticketPrice: "Price (£)",
    ticketQty: "Total Quantity",
    publishReadyTitle: "Ready to publish",
    publishReadyBody:
      "Confirm the city and choose whether to feature this event.",
    featuredEvent: "Featured Event",
    wizardBack: "Back",
    wizardNext: "Next",

    landingApplyKicker: "For Business",
    landingApplyHeading: "Apply to join",
    landingApplySubtitle:
      "Leave your details and we'll reach out with next steps.",
    landingApplyNameLabel: "Your name",
    landingApplyBusinessLabel: "Your business",
    landingApplyWebsiteLabel: "Website (optional)",
    landingApplyEmailLabel: "Email address",
    landingApplyPhoneLabel: "Phone number",
    landingApplySubmitBtn: "Submit",
    landingApplySuccess:
      "We've got your application — we'll be in touch soon with next steps.",
    landingApplyBackToLogin: "← Back to login",
    landingApplyError: "Something went wrong, please try again.",

    landingSignInKicker: "Member Sign In",
    landingSignInHeading: "Welcome back",
    landingSignInSubtitle:
      "Sign in to browse events and buy tickets on the web",
    landingSignInLoginBtn: "Sign in",
    landingSignInNoAccount: "Don't have an account?",
    landingSignInCreateAccount: "Create one",
    landingSignUpKicker: "Create Account",
    landingSignInHaveAccount: "Already have an account?",
    landingSignInBackToLogin: "Sign in",
    landingSignInError: "Incorrect email or password.",
    landingOrDivider: "or",
    landingGoogleError: "Google sign-in failed, please try again.",
    landingForgotNoEmail: "Please enter your email address first.",
    landingForgotSent: "Password reset link sent to your email.",
    landingForgotError: "Something went wrong, please try again.",

    landingFooterLangLabel: "中文",
    landingFooterAbout: "About",
    landingFooterWhatIsSp: "What is Small Potatoes?",
    landingFooterCities: "Cities",
    landingFooterCompany: "Company",
    landingFooterConnect: "Connect",
    landingFooterLanguage: "Language",
    landingFooterCopyright: "All rights reserved",
    landingFooterPrivacy: "Privacy Policy",

    landingNewsletterHeading: "Join the Newsletter for free",
    landingNewsletterBlurb:
      "Good places, hidden corners and things worth doing.",
    landingNewsletterEmailLabel: "Email address",
    landingNewsletterCityLabel: "City (optional)",
    landingNewsletterCityAll: "All cities",
    landingNewsletterConsent:
      "I'd like to receive occasional emails from Small Potatoes about places, guides and things worth doing.",
    landingNewsletterSubmitBtn: "Subscribe",
    landingNewsletterSubmitting: "Subscribing…",
    landingNewsletterSuccess: "You're on the list.",
    landingNewsletterError: "Something went wrong, please try again.",

    memberNavEvents: "Events",
    memberNavBenefits: "Benefits",
    memberNavOrders: "My Orders",
    memberNavAccount: "Account",
    memberNavForBusiness: "For Business",
    memberNavTicketScanning: "Ticket Scanning",
    memberNavSettings: "Settings",
    memberNavLogout: "Logout",

    memberEventsHeading: "Discover extraordinary events",
    memberEventsBody:
      "From intimate gatherings to citywide parties, small potatoes helps you find events worth going to — browse and book with ease.",
    memberUpcomingHeading: "Upcoming events",
    memberUpcomingSubtitle: "Upcoming events with small potatoes",
    memberFilterLabel: "Filter upcoming events by city:",
    memberAllCities: "All Cities",
    memberNoEvents: "No events found for the selected city.",
    memberPastHeading: "Past Events",
    memberPastSubtitle:
      "Relive the excitement of past events with small potatoes!",

    memberBenefitsTab: "Member benefits",
    memberVoucherHeading: "Your member benefits",
    memberVoucherIntro:
      "As a small potatoes member, you get early access to tickets, business surprises, and exclusive local deals.",
    memberValidLabel: "valid:",
    memberCardDetails: "Card details",
    memberBenefit1Title: "Early-bird event tickets",
    memberBenefit1Body: "First access to tickets for popular events",
    memberBenefit2Title: "Business blind box",
    memberBenefit2Body: "Unlock surprise perks from partner businesses",
    memberBenefit3Title: "Curated exclusive deals",
    memberBenefit3Body: "Member-only discounts hand-picked by our local team",
    memberDealsHeading: "Exclusive deals",
    memberDealsSubtitle: "Click on them to show at checkout and enjoy",

    memberOrdersHeading: "Your tickets and orders live here",
    memberOrdersBody: "Purchased event tickets and bookings will show up here.",
    memberExploreEvents: "Explore Events",
    memberExpiredTickets: "Past Orders",

    purchaseInfoLocation: "Location",
    purchaseInfoBookingFee: "Booking fee",
    purchaseInfoTotal: "Total paid",
    purchaseInfoPurchaseDate: "Purchase date",
    purchaseInfoBuyerInfo: "Buyer info",

    memberVoucherBack: "Benefits",
    memberVoucherValidUntil: "Valid until",
    memberVoucherShowStaff: "Show this to staff",
    memberVoucherTermsApply: "Terms and conditions apply",
    memberVoucherNoTerms: "No terms and conditions provided for this voucher.",

    eventDetailBackToEvents: "← Back to events",
    eventDetailDateTime: "Date & Time",
    eventDetailLocation: "Location",
    eventDetailLastEntry: "Last Entry",
    eventDetailAge: "Age Restriction",
    eventDetailVendor: "Vendor",
    eventDetailTickets: "Tickets",
    eventDetailSelected: "selected",
    eventDetailBookingFee: "booking fee",
    eventDetailBuyTickets: "Buy tickets",
    eventDetailFree: "Free",
    eventDetailSoldOut: "Sold Out",
    eventDetailSalesEnded: "Sales Ended",
    eventDetailTicketsComingSoon: "Tickets coming soon!",
    eventDetailTicketsComingSoonBody:
      "Check back later for updates on ticket availability.",
    eventDetailShare: "Share",
    eventDetailLinkCopied: "Link copied to clipboard!",

    settingsAccountDetails: "Account Details",
    settingsUsername: "Username",
    settingsEmail: "Email",
    language: "Language",
    settingsBack: "Back",
    settingsUpdateSuccess: "Profile updated successfully!",
    settingsUpdateError: "Please make sure all fields are filled in correctly.",
    tooManyLoginAttempts:
      "Too many login attempts. Please try again in 15 minutes, or contact an administrator.",

    routeErrorHeading: "Something went wrong",
    routeErrorChunkBody:
      "This page couldn't load, probably a brief network hiccup. Reloading usually fixes it.",
    routeErrorGenericBody:
      "An unexpected error occurred while loading this page.",
    routeErrorReload: "Reload page",
    routeErrorGoHome: "Go home",
    // Add more translations here
  },
  zh: {
    profile: "个人资料",
    settings: "设置",
    login: "登录",
    logout: "登出",
    noCards: "没有可用的卡",
    vouchers: "会员福利",
    tickets: "票",
    noVouchers: "没有可用的优惠券",
    redeem: "兑换",
    adminDashboard: "管理员仪表板",
    mobile: "手机号码",
    save: "保存",
    saveChanges: "保存更改",
    yourCards: "你的卡片",
    moreVouchersComingSoon: "更多优惠券即将到来",
    moreEventsComingSoon: "更多活动即将推出！",
    noTickets: "没有可用的票",
    currencyConversions: "货币按实时汇率自动转换",
    nonRefundable: "所有购买门票不可退款",
    vouchersDescription:
      "这些是伯明翰的餐饮、娱乐优惠券，点击并在结账时出示即可享受优惠",
    trialPopupTitle: "欢迎使用我们的试用版！",
    trialPopupDescription:
      "您已获得访问我们新优惠券系统的权限。探索并享受这些优惠！",
    dismissButton: "关闭",
    cityfilter: "按城市过滤即将到来的活动",

    cookieConsentMessage:
      "我们使用 Cookie 来运行本网站；在获得你同意后,也会用它来了解网站的使用情况,以便持续改进。",
    cookieConsentLearnMore: "了解更多",
    cookieConsentAcceptAll: "接受全部",
    cookieConsentRejectAll: "仅必要",
    cookieConsentCustomize: "自定义",
    cookieConsentBack: "返回",
    cookieConsentSavePreferences: "保存设置",
    cookieConsentNecessaryTitle: "必要 Cookie",
    cookieConsentNecessaryBody: "网站正常运行所必需,无法关闭。",
    cookieConsentAnalyticsTitle: "分析 Cookie",
    cookieConsentAnalyticsBody:
      "帮助我们了解网站使用情况,以便持续改进产品体验。",
    cookieConsentAlwaysOn: "始终开启",

    // Landing page
    landingNavTatoClub: "Tato Club",
    landingNavOffers: "会员优惠",
    landingNavListEvent: "发布活动",
    landingNavPartner: "成为合作伙伴",
    landingNavAbout: "关于我们",
    landingNavBusiness: "商家入驻",
    landingNavDownload: "下载 App",
    landingNavSignin: "登录",
    landingNavJoin: "加入",
    landingNavBack: "← 返回官网",

    landingHeroKicker: "一份来自 Small Potatoes 的城市指南",
    landingHeroTitle: "发现城市里好吃、好玩、好去处。",
    landingHeroSubtitle:
      "精选活动门票 + 本地好去处,由 Small Potatoes 帮你一次找齐。",
    landingHeroCtaPrimary: "探索你的城市",
    landingHeroCtaSecondary: "加入 Tato Club",
    landingHeroCtaSecondaryNote: "Small Potatoes 会员应用",
    landingHeroCitiesLabel: "目前服务于",
    landingHeroFeature1: "活动购票",
    landingHeroFeature2: "好去处推荐",
    landingHeroFeature3: "会员专属福利",

    landingPicksKicker: "精选推荐",
    landingPicksBadge: "Small Potatoes 之选",
    landingPicksHeading: "{city} 十大好去处",
    landingPicksSubtitle: "每一处都有它值得被选中的理由。",
    landingPicksCtaMore: "查看全部好去处",
    landingPicksBackToHome: "← 返回首页",
    landingPicksBackToList: "← 返回列表",
    landingPicksHighlightsHeading: "特色推荐",
    landingPicksDetailsHeading: "地点详情",
    landingPicksMorePlacesHeading: "更多本地推荐",

    // 「按心情筛选」—— {city}、{vibe} 在渲染时替换。各 vibe 的 SEO 文案用于
    // /places/:city/mood/:vibe 落地页。
    vibeFilterAll: "全部",
    vibeFilterEmpty: "{city} 暂时还没有适合{vibe}的地方,晚点再来看看。",
    vibeHomeKicker: "按心情找",
    vibeHomeHeading: "今天想去什么样的地方?",
    vibeHomeSubtitle: "选一个场合,我们帮你挑对应的地方。",
    vibeDateNightLabel: "约会",
    vibeWithTheGroupLabel: "朋友聚会",
    vibeSoloLabel: "一个人",
    vibeFamilyLabel: "亲子",
    vibeSpecialOccasionLabel: "特别场合",
    vibeQuickBiteLabel: "随便吃点",
    vibeRainyDayLabel: "下雨天",
    vibeWorkFriendlyLabel: "适合办公",
    vibeDogFriendlyLabel: "宠物友好",
    vibeDateNightSeoTitle: "{city} 约会好去处 | Small Potatoes",
    vibeDateNightSeoDesc: "我们在 {city} 精选的适合约会的独立小店。",
    vibeWithTheGroupSeoTitle: "{city} 朋友聚会好去处 | Small Potatoes",
    vibeWithTheGroupSeoDesc: "我们在 {city} 精选的适合朋友聚会的独立小店。",
    vibeSoloSeoTitle: "{city} 适合一个人待着的地方 | Small Potatoes",
    vibeSoloSeoDesc: "我们在 {city} 精选的适合一个人待着的独立小店。",
    vibeFamilySeoTitle: "{city} 亲子好去处 | Small Potatoes",
    vibeFamilySeoDesc: "我们在 {city} 精选的适合带娃出门的独立小店。",
    vibeSpecialOccasionSeoTitle: "{city} 特别场合好去处 | Small Potatoes",
    vibeSpecialOccasionSeoDesc: "我们在 {city} 精选的适合庆祝特别日子的独立小店。",
    vibeQuickBiteSeoTitle: "{city} 随便吃点的好去处 | Small Potatoes",
    vibeQuickBiteSeoDesc: "我们在 {city} 精选的适合快速解决一餐的独立小店。",
    vibeRainyDaySeoTitle: "{city} 下雨天好去处 | Small Potatoes",
    vibeRainyDaySeoDesc: "我们在 {city} 精选的适合下雨天窝着的独立小店。",
    vibeWorkFriendlySeoTitle: "{city} 适合办公的好去处 | Small Potatoes",
    vibeWorkFriendlySeoDesc: "我们在 {city} 精选的适合坐下来办公的独立小店。",
    vibeDogFriendlySeoTitle: "{city} 宠物友好好去处 | Small Potatoes",
    vibeDogFriendlySeoDesc: "我们在 {city} 精选的可以带狗出门的独立小店。",

    shareLabel: "分享",
    shareCopied: "链接已复制!",

    navGuides: "指南",

    guidesKicker: "指南",
    guidesHeading: "探索{city}的方式",
    guidesHeadingAll: "探索这座城市的方式",
    guidesSubtitle:
      "精心策划的路线,带你走进值得一去的地方——无论是悠闲的下午、雨天,还是想探索点新鲜的。",
    guidesBackToHome: "← 返回首页",
    guidesBackToGuides: "← 返回指南",
    guidesEmptyTitle: "更多指南即将上线。",
    guidesEmptyBody: "我们还在撰写中,请稍后回来查看探索{city}的新方式。",
    guidesEmptyBodyAll: "我们还在撰写中,请稍后回来查看探索这座城市的新方式。",
    guidesErrorTitle: "出了点问题。",
    guidesErrorBody: "暂时无法加载这些指南,请稍后再试。",
    guidesNotFoundTitle: "未找到该指南",
    guidesNotFoundBody: "该指南不存在,或可能已下线。",
    notFoundTitle: "未找到该页面",
    notFoundBody: "我们找不到您要访问的页面,它可能已被移动,或链接已失效。",
    notFoundBackHome: "← 返回首页",
    guidesCardCta: "阅读指南",
    guideTypeGuide: "指南",
    guideTypeItinerary: "行程",
    guideTypeRoundup: "合集",
    guideTypeStory: "故事",
    guidePlaceCardCta: "查看地点",
    guideMetaSeparator: "·",

    landingEventsKicker: "活动",
    landingEventsHeading: "{city} 本月活动",
    landingEventsSubtitle: "按城市查看近期演出与活动",
    landingEventsCtaMore: "在 App 中查看全部并购票",
    landingEventsEmpty: "这个城市暂时还没有活动,敬请期待。",

    landingOffersHeading: "会员优惠",
    landingOffersSubtitle: "加入 Tato Club,每一笔消费都能省一点。",
    landingOffersBadge: "会员福利",

    landingGuidesKicker: "指南",
    landingGuidesHeading: "最新指南",
    landingGuidesSubtitle: "精心策划的路线,带你吃喝玩乐、探索这座城市。",
    landingGuidesCtaMore: "查看全部指南",

    landingTatoClubKicker: "Tato Club",
    landingTatoClubHeading: "把 Small Potatoes 装进口袋",
    landingTatoClubBody:
      "加入 Tato Club,收藏喜爱的地点、解锁会员专属优惠,并发现下一步该去哪儿。",
    landingTatoClubCta: "下载 Tato Club",
    landingTatoClubSecondary: "Small Potatoes 官方会员应用",

    landingAboutKicker: "关于我们",
    landingAboutHeading: "我们相信,城市的性格藏在细节里",
    landingAboutBody:
      "Small Potatoes 始于一群在英国生活的年轻人。我们常常为了找到一家真正喜欢的餐厅、一场值得去的活动,在零散的信息里花很多时间。",
    landingAboutValue1Title: "值得信赖的推荐",
    landingAboutValue1Body: "每一处好去处都经过本地团队走访",
    landingAboutValue2Title: "购票即时到手",
    landingAboutValue2Body: "演出、市集门票随买随用,无需打印",
    landingAboutValue3Title: "持续更新的城市指南",
    landingAboutValue3Body: "新店铺、新活动第一时间收录",
    landingAboutStoryKicker: "我们的故事",
    landingAboutStoryHeading: "构成一座城市的,不只是最响亮的名字",
    landingAboutStoryBody:
      "后来我们发现,构成一座城市的,往往不只是最响亮的名字,而是那些有自己坚持、也让人愿意再次回去的地方。我们把活动、独立场所和本地体验放在一起,希望每一次推荐,都能让你多认识这座城市一点。",
    landingAboutBeliefQuote:
      "“每一个 Small Potatoes 之选,都由本地团队亲自体验和挑选。”",
    landingAboutClosingHeading: "用我们的方式,给生活多一点色彩",
    landingAboutClosingBody:
      "这也是为什么我们为会员准备了更多福利 —— 早鸟门票、商家盲盒和专属优惠,希望探索这件事,一直值得。",
    landingAboutClosingCta: "成为会员",

    landingBizTeaserHeading: "经营本地生意?",
    landingBizTeaserBody:
      "在 Small Potatoes 上发布活动,或让更多人发现你的空间。",
    landingBizTeaserCta: "成为合作伙伴",

    landingBizPortalKicker: "商家专属",
    landingBizPortalHeading: "欢迎回来",
    landingBizPortalSubtitle: "登录管理你的活动与门店信息",
    landingBizPortalEmailLabel: "邮箱",
    landingBizPortalPasswordLabel: "密码",
    landingBizPortalForgot: "忘记密码?",
    landingBizPortalLoginBtn: "登录",
    landingBizPortalNoAccount: "还没有商家账号?",
    landingBizPortalApply: "申请入驻",
    landingBizPortalSideKicker: "商家专属",
    landingBizPortalSideHeading: "为什么加入 small potatoes",
    landingBizPortalSide1: "触达真正在附近寻找去处的用户",
    landingBizPortalSide1Sub: "连接伦敦、伯明翰与南安普顿的本地探索者",
    landingBizPortalSide2: "简单的活动发布与票务管理",
    landingBizPortalSide2Sub: "几分钟内上线活动,轻松追踪销售情况",
    landingBizPortalSide3: "一个门户,管理门店信息与活动",
    landingBizPortalSide3Sub: "门店信息、优惠与活动集中管理",
    landingBizPortalLoginError: "邮箱或密码不正确。",

    dashTabEvents: "活动",
    dashTabUsers: "用户",
    dashTabCards: "会员卡",
    dashTabStores: "地点",
    dashTabVouchers: "优惠券",
    dashTabPosts: "文章",
    dashTabNewsletter: "邮件订阅",
    dashAccount: "Small Potatoes 账户",
    dashSwitchToMember: "切换到用户页面",
    dashUpcoming: "即将开始",
    dashPast: "往期",
    dashAllCities: "全部城市",
    dashAllStatuses: "全部状态",
    dashFilterByCity: "按城市筛选活动",
    dashCreateEvent: "创建活动",
    dashColSales: "销量",
    dashColRevenue: "收入",
    dashTotalUsers: "注册用户总数",
    dashCopyEmails: "复制营销邮箱",
    dashSearchUser: "按姓名或邮箱搜索…",
    dashQuickSearch: "搜索活动、用户或地点…",
    dashNoResults: "没有找到匹配结果",
    dashWorkspace: "工作台",
    dashEventsSubtitle: "管理你的活动与票务",
    dashNewsletterSubtitle: "查看订阅了土豆信件的用户",
    dashNewsletterTotal: "总数",
    dashNewsletterSubscribed: "已订阅",
    dashNewsletterUnsubscribed: "已退订",
    dashNewsletterStatusSubscribed: "已订阅",
    dashNewsletterStatusUnsubscribed: "已退订",
    dashNewsletterAllCities: "所有城市",
    dashNewsletterConsented: "同意时间",
    dashNewsletterUnsubscribedOn: "退订时间",
    dashNewsletterEmpty: "暂时还没有订阅者。",
    dashNewsletterError: "加载订阅者失败,请重试。",
    addMember: "添加成员",
    addMemberTitle: "添加新成员",
    addMemberSubtitle: "邀请团队成员并设置权限",
    editMemberTitle: "编辑成员",
    editMemberSubtitle: "更新成员的角色与权限",
    memberEmailLabel: "邮箱地址",
    memberEmailPh: "输入成员的邮箱地址",
    memberRoleLabel: "角色",
    roleUser: "用户",
    roleCreator: "创建者",
    roleObserver: "观察者",
    roleStaff: "工作人员",
    roleCreatorHint: "可管理分配给TA的活动",
    roleObserverHint: "可查看分配给TA的活动数据",
    roleStaffHint: "可在指定活动进行票务核销",
    memberEventsLabel: "分配活动",
    memberEventsEmpty: "暂无活动。",
    sendInvite: "发送邀请",
    saveMemberChanges: "保存修改",
    memberEmailExists: "该邮箱已有账号,请从列表中选择编辑。",
    memberEmailRequired: "请输入邮箱地址。",
    memberInviteSent: "邀请已发送!",
    memberSaved: "成员信息已更新。",
    edit: "编辑",
    delete: "删除",
    backToEventsList: "← 返回活动",
    detailVendor: "主办方",
    detailPriceRange: "票价区间",
    detailSalesEnd: "停售时间",
    detailLastEntry: "最晚入场",
    detailAge: "年龄限制",
    detailFeatured: "推荐位",
    ticketTypesLabel: "票种",
    qtyLabel: "数量",
    soldLabel: "已售",
    availableLabel: "剩余",
    totalCreatedLabel: "已生成门票",
    totalScannedLabel: "已核销",
    panelFinancials: "财务",
    panelReferrals: "推荐码",
    panelFreeTickets: "免费票",
    panelPermissions: "权限",
    finTotalRevenue: "总收入",
    finOwedOrganizer: "应付主办方",
    finOwedUs: "应付平台",
    finStripeFee: "预估手续费",
    finTotalOrders: "订单总数",
    generateReferral: "生成推荐码",
    noReferrals: "暂无推荐码",
    issueFreeTicket: "发放免费票",
    guestEmail: "嘉宾邮箱",
    guestName: "嘉宾姓名",
    selectTicketType: "选择票种",
    freeReason: "发放原因",
    maxEntry: "最大入场次数",
    maxEntryHint: "该票可被扫描的次数",
    issuedTickets: "已发放的免费票",
    permissionsHint: "管理团队成员对此活动的访问权限。",
    noMembers: "还没有添加成员",
    addNow: "立即添加",
    dashCreateCard: "创建新会员卡",
    dashCardName: "卡片名称",
    dashIdNumber: "识别码",
    dashPaid: "已付款",
    dashAutoAssign: "自动分配给新用户",
    dashColExpiry: "到期日",
    dashEnterEmail: "输入用户邮箱",
    dashAssignUser: "分配给用户",
    dashAssignAll: "分配全部",
    dashNewCompany: "新建地点",
    dashAllCards: "全部会员卡",
    dashNewVoucher: "新建优惠券",
    dashCancel: "取消",
    statTotalEvents: "活动总数",
    statTotalSales: "总销量",
    statTotalRevenue: "总收入",

    dashCreateCompanyTitle: "新建地点",
    dashEditCompanyTitle: "编辑地点",
    dashUpdateCompanyBtn: "更新地点",
    dashCompanyPhoto: "地点封面图",
    dashDropPhoto: "拖入地点图片",
    dashBrowseFiles: "浏览文件",
    dashCompanyNameLabel: "地点名称",
    dashCompanyNamePh: "输入地点名称",
    dashShortDescLabel: "简短描述",
    dashShortDescPh: "一句话概括这个地点",
    dashMaxChars: "最多 100 字",
    dashCompanyDescLabel: "详细描述",
    dashCompanyDescPh: "介绍这个地点的特色与亮点",
    dashCompanyLocationLabel: "详细地址",
    dashCompanyLocationPh: "输入具体地址",
    dashCompanyWebsiteLabel: "官网链接",
    dashCompanyWebsitePh: "https://example.com",
    dashCompanyContactLabel: "联系电话",
    dashCompanyContactPh: "输入联系电话",
    dashCategoryLabel: "分类",
    dashCategoryPh: "例如 酒吧、咖啡馆、现场演出",
    dashTagsLabel: "标签",
    dashTagsPh: "用逗号分隔的自由描述词,例如 鸡尾酒、自然酒、露台",
    dashVibesLabel: "适合场合",
    dashVibesHint: "这个地方适合什么场合?勾选后会出现在「按心情筛选」里,最多选 3 个。",
    dashHighlightsLabel: "特色亮点",
    dashHighlightsPh: "每行一条亮点",
    dashHighlightsHint: "会以勾选列表的形式显示在商家详情页",
    dashFeaturedCompany: "设为星标地点",
    dashVoucherPlaceLabel: "地点",
    dashSelectPlace: "选择一个地点",

    dashNewPost: "新建文章",
    dashCreatePostTitle: "新建文章",
    dashEditPostTitle: "编辑文章",
    dashUpdatePostBtn: "更新文章",
    dashPostTitleLabel: "标题",
    dashPostTitlePh: "例如 南安普顿的悠闲周日",
    dashPostTypeLabel: "文章类型",
    dashPostTypeGuide: "指南",
    dashPostTypeItinerary: "行程",
    dashPostTypeRoundup: "合集",
    dashPostTypeStory: "故事",
    dashPostExcerptLabel: "摘要",
    dashPostExcerptPh: "显示在列表中的简短摘要",
    dashPostHeroImageLabel: "封面图",
    dashDropHeroImage: "拖入封面图片",
    dashPostIntroductionLabel: "引言",
    dashPostIntroductionPh: "在第一个板块之前,先做个开场…",
    dashPostTagsPh: "用逗号分隔,例如 咖啡、雨天、亲子",
    dashPostStatusLabel: "状态",
    dashPostStatusDraft: "草稿",
    dashPostStatusPublished: "已发布",
    dashPostSectionsLabel: "内容板块",
    dashPostSection: "板块",
    dashPostSectionHeadingLabel: "小标题",
    dashPostSectionHeadingPh: "例如 从一杯咖啡开始",
    dashPostSectionBodyLabel: "正文",
    dashPostSectionBodyPh: "写点什么…",
    dashPostSectionPlaceNone: "未选择地点",
    dashAddSection: "+ 添加板块",
    dashRemoveSection: "删除",
    dashMoveSectionUp: "上移",
    dashMoveSectionDown: "下移",
    dashNoPosts: "暂无文章,创建一篇新文章开始吧。",

    dashPostStepCover: "封面",
    dashPostStepContent: "正文",
    dashPostStepPublish: "发布",
    dashPostStepRequiredError: "请先填写必填项再继续。",
    dashPostStepBack: "上一步",
    dashPostStepContinue: "下一步",
    dashPostSaveDraft: "存为草稿",
    dashPostPublish: "发布",
    dashPostPublishUpdate: "保存更改",

    dashPlaceStepCover: "封面",
    dashPlaceStepContent: "正文",
    dashPlaceStepDetails: "详情",

    dashEditorBold: "加粗",
    dashEditorItalic: "斜体",
    dashEditorUnderline: "下划线",
    dashEditorBulletList: "无序列表",
    dashEditorOrderedList: "有序列表",
    dashEditorQuote: "引用",
    dashEditorLink: "链接",
    dashEditorImage: "图片",
    dashEditorAlignLeft: "左对齐",
    dashEditorAlignCenter: "居中对齐",
    dashEditorAlignRight: "右对齐",
    dashEditorHeading2: "标题",
    dashEditorHeading3: "副标题",
    dashEditorLinkPrompt: "输入链接地址",
    dashEditorLinkConfirm: "添加",
    dashEditorLinkRemove: "移除",
    dashEditorImageUploadError: "图片上传失败,请重试。",
    dashEditorFontLabel: "字体",
    dashEditorFontDefault: "默认字体",
    dashEditorFontBody: "正文体(Figtree)",
    dashEditorFontHeading: "标题体(Caprasimo)",
    dashEditorFontPoppins: "Poppins",

    createEventTitle: "创建新活动",
    editEventTitle: "编辑活动",
    updateEventBtn: "更新活动",
    stepBasics: "基本信息",
    stepDetails: "详情",
    stepTickets: "票种",
    stepPublish: "发布",
    sectionImages: "活动图片",
    sectionCity: "城市",
    fieldTitle: "活动标题",
    fieldTitlePh: "为你的活动取一个吸引人的标题",
    fieldShortDesc: "简短描述",
    fieldShortDescPh: "一句话概括你的活动(最多120字)",
    fieldFullDesc: "详细描述",
    fieldFullDescPh: "详细介绍你的活动",
    fieldStart: "开始时间",
    fieldEnd: "结束时间(选填)",
    fieldLocation: "活动地点",
    fieldLocationPh: "输入活动场地或地址",
    fieldVendor: "主办方",
    fieldVendorPh: "活动组织者或主办方名称",
    fieldPriceRange: "票价区间",
    fieldPriceRangePh: "例如 £20 – £50",
    fieldLastEntry: "最晚入场时间",
    fieldLastEntryPh: "例如 晚11:00",
    fieldAge: "年龄限制",
    fieldAgePh: "例如 18+、不限",
    fieldCutoff: "停止售票时间",
    fieldCutoffHint: "留空则可售票至活动开始",
    selectCity: "选择城市",
    citySearchPlaceholder: "搜索或输入新城市名称",
    addCityLabel: "添加城市",
    cityRequiredError: "请选择或添加城市。",
    ticketsStepHint: "至少添加一种票",
    addTicketType: "添加票种",
    ticketNamePh: "例如 早鸟票、VIP",
    ticketBadgePh: "例如 EARLY、VIP",
    ticketDescPh: "简要描述该票种的权益",
    ticketPrice: "价格(£)",
    ticketQty: "总数量",
    publishReadyTitle: "准备发布",
    publishReadyBody: "确认城市并选择是否设为推荐活动。",
    featuredEvent: "设为推荐活动",
    wizardBack: "上一步",
    wizardNext: "下一步",

    landingApplyKicker: "商家入驻",
    landingApplyHeading: "申请入驻",
    landingApplySubtitle: "留下你的信息,我们会联系你介绍如何入驻。",
    landingApplyNameLabel: "你的姓名",
    landingApplyBusinessLabel: "商家名称",
    landingApplyWebsiteLabel: "网站(选填)",
    landingApplyEmailLabel: "邮箱",
    landingApplyPhoneLabel: "电话",
    landingApplySubmitBtn: "提交申请",
    landingApplySuccess: "已收到你的申请!我们会尽快联系你介绍入驻流程。",
    landingApplyBackToLogin: "← 返回登录",
    landingApplyError: "提交失败,请重试。",

    landingSignInKicker: "会员登录",
    landingSignInHeading: "欢迎回来",
    landingSignInSubtitle: "登录后可在网页浏览活动并购票",
    landingSignInLoginBtn: "登录",
    landingSignInNoAccount: "还没有账号?",
    landingSignInCreateAccount: "立即注册",
    landingSignUpKicker: "创建账号",
    landingSignInHaveAccount: "已经有账号了?",
    landingSignInBackToLogin: "去登录",
    landingSignInError: "邮箱或密码不正确。",
    landingOrDivider: "或",
    landingGoogleError: "Google 登录失败,请重试。",
    landingForgotNoEmail: "请先输入邮箱地址。",
    landingForgotSent: "密码重置链接已发送到你的邮箱。",
    landingForgotError: "出错了,请重试。",

    landingFooterLangLabel: "English",
    landingFooterAbout: "关于我们",
    landingFooterWhatIsSp: "什么是 Small Potatoes?",
    landingFooterCities: "城市",
    landingFooterCompany: "公司",
    landingFooterConnect: "联系我们",
    landingFooterLanguage: "语言",
    landingFooterCopyright: "保留所有权利",
    landingFooterPrivacy: "隐私政策",

    landingNewsletterHeading: "土豆信件",
    landingNewsletterBlurb: "好去处、小众角落,以及值得一试的新鲜事。",
    landingNewsletterEmailLabel: "邮箱",
    landingNewsletterCityLabel: "城市(选填)",
    landingNewsletterCityAll: "所有城市",
    landingNewsletterConsent:
      "我愿意不定期收到 Small Potatoes 关于好去处、指南和值得一试的新鲜事的邮件。",
    landingNewsletterSubmitBtn: "订阅",
    landingNewsletterSubmitting: "订阅中…",
    landingNewsletterSuccess: "订阅成功,欢迎加入!",
    landingNewsletterError: "出错了,请重试。",

    memberNavEvents: "活动",
    memberNavBenefits: "会员福利",
    memberNavOrders: "我的订单",
    memberNavAccount: "账户",
    memberNavForBusiness: "商家入驻",
    memberNavTicketScanning: "门票核销",
    memberNavSettings: "设置",
    memberNavLogout: "登出",

    memberEventsHeading: "发现精彩活动",
    memberEventsBody:
      "从小型聚会到城市大派对,small potatoes 帮你找到值得参加的活动,轻松浏览、预订。",
    memberUpcomingHeading: "近期活动",
    memberUpcomingSubtitle: "small potatoes 的近期活动",
    memberFilterLabel: "按城市筛选:",
    memberAllCities: "全部城市",
    memberNoEvents: "该城市暂无近期活动。",
    memberPastHeading: "往期活动",
    memberPastSubtitle: "回顾 small potatoes 精彩瞬间",

    memberBenefitsTab: "会员福利",
    memberVoucherHeading: "你的会员福利",
    memberVoucherIntro:
      "作为 small potatoes 会员,你可以优先购票、发现惊喜商家,并解锁本地专属优惠。",
    memberValidLabel: "有效期至",
    memberCardDetails: "查看卡片详情",
    memberBenefit1Title: "活动早鸟票",
    memberBenefit1Body: "会员优先购买热门活动门票",
    memberBenefit2Title: "商家盲盒",
    memberBenefit2Body: "不定期解锁惊喜合作商家福利",
    memberBenefit3Title: "专属优惠推荐",
    memberBenefit3Body: "由本地团队精选的会员专属折扣",
    memberDealsHeading: "专属优惠",
    memberDealsSubtitle: "点击后到店出示即可使用",

    memberOrdersHeading: "这里是你的门票与订单",
    memberOrdersBody: "已购买的活动门票和预订记录会显示在这里。",
    memberExploreEvents: "浏览活动",
    memberExpiredTickets: "往期订单",

    purchaseInfoLocation: "活动地点",
    purchaseInfoBookingFee: "服务费",
    purchaseInfoTotal: "实付金额",
    purchaseInfoPurchaseDate: "购买日期",
    purchaseInfoBuyerInfo: "购票人信息",

    memberVoucherBack: "会员福利",
    memberVoucherValidUntil: "有效期至",
    memberVoucherShowStaff: "出示给店员",
    memberVoucherTermsApply: "适用条款",
    memberVoucherNoTerms: "暂无附加条款。",

    eventDetailBackToEvents: "← 返回活动",
    eventDetailDateTime: "时间",
    eventDetailLocation: "地点",
    eventDetailLastEntry: "最晚入场",
    eventDetailAge: "年龄限制",
    eventDetailVendor: "主办方",
    eventDetailTickets: "选择门票",
    eventDetailSelected: "已选",
    eventDetailBookingFee: "服务费",
    eventDetailBuyTickets: "购买门票",
    eventDetailFree: "免费",
    eventDetailSoldOut: "已售罄",
    eventDetailSalesEnded: "已停售",
    eventDetailTicketsComingSoon: "门票即将开售!",
    eventDetailTicketsComingSoonBody: "请稍后查看门票开售情况。",
    eventDetailShare: "分享",
    eventDetailLinkCopied: "链接已复制到剪贴板!",

    settingsAccountDetails: "账户信息",
    settingsUsername: "用户名",
    settingsEmail: "邮箱",
    language: "语言",
    settingsBack: "返回",
    settingsUpdateSuccess: "资料更新成功!",
    settingsUpdateError: "请确认所有字段都已正确填写。",
    tooManyLoginAttempts: "登录尝试次数过多,请 15 分钟后再试,或联系管理员。",

    routeErrorHeading: "出错了",
    routeErrorChunkBody:
      "页面加载失败,可能是网络短暂波动,刷新一下通常就能解决。",
    routeErrorGenericBody: "加载此页面时发生了意外错误。",
    routeErrorReload: "刷新页面",
    routeErrorGoHome: "返回首页",
    // Add more translations here
  },
};
